import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { Video } from '../../../../vtex-apps/Video/default';

export default function VideoGroup() {
	return {
		componentName: 'FlexLayoutRow',
		componentId: uuidv4(),
		componentGroup: 'VideoGroup',
		variables,
		props: FlexLayoutRow({ blockClass: 'flex-row__video-group-1', colSizing: 'auto', mzTitle: 'MZ | Video' }).props,
		childrenComponents: [
			Video({
				blockClass: 'video__video-group-1',
			}),
		],
	};
}

//variable with type color for flexrow bg
const variables = [
	{
		type: 'color',
		list: [{ from: '--transparent', to: '--vg-1-bg-color', name: 'Background' }],
	},
];
